import { Badge, Popover, Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { HiUserCircle } from 'react-icons/hi';
import { MdOutlineConnectedTv, MdOutlineDataSaverOff, MdOutlineQueryStats } from 'react-icons/md';
import { RiBuildingLine, RiDoorOpenFill, RiUserSettingsLine } from 'react-icons/ri';
import { VscBell } from 'react-icons/vsc';
import { Link, useHistory } from 'react-router-dom';
import { useAuth } from '../../../hooks/auth';
import Routes from '../routes';

import logo from '../../../assets/logo.png';

import { Aside, Container, Content } from './styles';

import NotificationsPopUp from '../components/NotificationsPopUp';
import AdminToolContent from './AdminToolContent';

const Layout: React.FC = () => {
  const { signOut, user } = useAuth();
  const history = useHistory();
  const location = history.location.pathname;
  const [signOutPopUpAnchor, setSignOuPopUpAnchor] = useState<Element | null>(null);
  const [notificationsPopUpAnchor, setNotificationsPopUpAnchor] = useState<Element | null>(null);
  const [notification, setNotification] = useState(0);

  const isSignOutPopUpOpen = Boolean(signOutPopUpAnchor);
  const isNotificationsPopUpOpen = Boolean(notificationsPopUpAnchor);

  const handleCloseSignOutPopUp = (): void => setSignOuPopUpAnchor(null);
  const handleCloseNotificationsPopUp = (): void => setNotificationsPopUpAnchor(null);

  const UserLogo = (
    <div>
      {user.avatar_url ? (
        <img src={user.avatar_url || ''} alt="logo" className="logo" />
      ) : (
        <img src={logo || ''} alt="logo" className="logo" />
      )}
    </div>
  );
  const showAdminTool = user.sysadmin || user.permissions?.includes('|level-admin|') || user.permissions?.includes('|level-manager|'); 
  const menuClients = user.sysadmin || user.permissions?.includes('|clients|');
  const menuDevices = user.sysadmin || user.permissions?.includes('device');
  const menuRoles = user.sysadmin || user.permissions?.includes('role')

  return (
    <>
        <Aside isAdmin={true}>
        <ul>
          <li>
            <Tooltip title="Dashboard">
              <Link to="/app/dashboard">
                <MdOutlineDataSaverOff className={location === '/app/dashboard' ? 'active' : ''} />
              </Link>
            </Tooltip>
          </li>
          {menuDevices && (
            <li>
              <Tooltip title="Monitor de Dispositivos">
                <Link to="/app/monitor">
                  <MdOutlineQueryStats className={location === '/app/monitor' ? 'active' : ''} />
                </Link>
              </Tooltip>
            </li>
          )}
          {menuClients && (
          <li>
            <Tooltip title="Clientes">
              <Link to="/app/clients">
                <RiBuildingLine className={location === '/app/clients' ? 'active' : ''} />
              </Link>
            </Tooltip>
          </li>
          )}
          {menuDevices && (
            <li>
              <Tooltip title="Dispositivos">
                <Link to="/app/device">
                  <MdOutlineConnectedTv className={location === '/app/device' ? 'active' : ''} />
                </Link>
              </Tooltip>
            </li>
          )}
          {menuRoles && (
          <li>
            <Tooltip title="Perfil">
              <Link to="/app/roles">
                <RiUserSettingsLine className={location === '/app/roles' ? 'active' : ''} />
              </Link>
            </Tooltip>
          </li>
          )}
          <li>
            <Tooltip title="Alertas">
              <Link to="/app/alerts">
                <FiAlertTriangle className={location === '/app/alerts' ? 'active' : ''} />
              </Link>
            </Tooltip>
          </li>
          <li>
            <Tooltip title={user.sysadmin || user.permissions?.includes('|level-admin|')
                         || user.permissions?.includes('|level-manager|') ? 
                         'Usuários' : 'Perfil'}>
              <Link to="/app/user">
                <HiUserCircle className={location === '/app/user' ? 'active' : ''} />
              </Link>
            </Tooltip>
          </li>
        </ul>
        <footer>
          {/* A estilização do Popover está no global.ts, pois o MUI cria um Portal */}
          <Popover
            open={isSignOutPopUpOpen}
            anchorEl={signOutPopUpAnchor}
            onClose={handleCloseSignOutPopUp}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
          >
            <div className="exitPopUp">
              <p>Deseja sair?</p>
              <section>
                <button type="button" onClick={handleCloseSignOutPopUp}>
                  Cancelar
                </button>
                <button type="button" onClick={() => signOut()}>
                  Sair
                </button>
              </section>
            </div>
          </Popover>
          <Tooltip title="Fazer log out" arrow placement="top">
            <button type="button" onClick={event => setSignOuPopUpAnchor(event.currentTarget)}>
              <RiDoorOpenFill />
            </button>
          </Tooltip>
        </footer>
      </Aside>

      <Container>
      {showAdminTool && location === '/app/dashboard' && <AdminToolContent />}
        <div className="appContent">
          <header>
            {UserLogo}
            <div className="headerUser">
              <p>{`Olá, ${user.name}`}</p>
              <NotificationsPopUp
                setNotification={setNotification}
                anchor={notificationsPopUpAnchor}
                handleClose={handleCloseNotificationsPopUp}
                isOpen={isNotificationsPopUpOpen}
              />
              <Tooltip title="Notificações">
                <button type="button" className="notificationButton" onClick={event => setNotificationsPopUpAnchor(event.currentTarget)}>
                  <Badge style={{ zIndex: 0 }} color="error" badgeContent={notification}>
                    <VscBell size={20} />
                  </Badge>
                </button>
              </Tooltip>
            </div>
          </header>
          <Content>
            <Routes />
          </Content>
        </div>
      </Container>
    </>
  );
};

export default Layout;
